import React from "react";
import { MainCP } from "../../Components/inflacion-mundial/MainCP"

const ViewInflacionMundial: React.FC = () => <MainCP/>
export default ViewInflacionMundial;